import { render, staticRenderFns } from "./PopupSignField.vue?vue&type=template&id=70f7dd0a&scoped=true"
import script from "./PopupSignField.vue?vue&type=script&lang=js"
export * from "./PopupSignField.vue?vue&type=script&lang=js"
import style0 from "./PopupSignField.vue?vue&type=style&index=0&id=70f7dd0a&prod&lang=css"
import style1 from "./PopupSignField.vue?vue&type=style&index=1&id=70f7dd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f7dd0a",
  null
  
)

export default component.exports